"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { ArrowUpRight } from "lucide-react";
function CuratedCollectionsConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className={`aspect-[3/4] w-full animate-pulse bg-muted ${i === 1 ? "md:mt-24" : i === 2 ? "md:mt-12" : ""}`} />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-muted-foreground mb-4">
          Failed to load botanical categories.
        </p>
        <button onClick={refetch} className="text-sm font-medium underline underline-offset-4 hover:text-primary transition-colors">
          Try again
        </button>
      </div>;
  }
  if (terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-8 lg:gap-12">
      {terms.slice(0, 3).map((term, i) => <div key={term.id} data-index={i} className={`group relative overflow-hidden rounded-md ${i === 1 ? "md:mt-24" : i === 2 ? "md:mt-12" : ""}`}>
          <Link to={term.link || "/ShopPage"} className="block h-full w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            <div className="aspect-[3/4] w-full overflow-hidden bg-secondary">
              {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-all duration-1000 ease-in-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted">
                  <span className="text-muted-foreground font-default text-xs uppercase tracking-[0.2em]">
                    {term.name}
                  </span>
                </div>}
              {}
              <div className="absolute inset-0 bg-secondary/40 opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
            </div>

            <div className="absolute bottom-6 left-6 flex items-center gap-3 bg-background/90 px-6 py-4 backdrop-blur-md transition-all duration-700 ease-out group-hover:-translate-y-2 shadow-md rounded-md">
              <h3 className="font-default text-xs font-semibold uppercase tracking-[0.2em] text-foreground">
                {term.name}
              </h3>
              <ArrowUpRight className="h-3 w-3 text-primary transition-colors group-hover:text-accent-foreground" />
            </div>
          </Link>
        </div>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function CuratedCollections() {
  return <section data-section-id="225097" id="seasonal-bloom-categories" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <h2 className="font-serif text-4xl font-light tracking-tight text-foreground md:text-6xl">
            Botanical Selections
          </h2>
          <p className="mt-6 text-base text-muted-foreground md:text-lg leading-relaxed font-default max-w-md">
            Discover our garden-grown varieties, from seasonal bouquets to ornamental treasures harvested at their peak.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query} className="curated-collections-wrapper">
          <CuratedCollectionsConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}